(function () {
  if (!window.POPUPS_DATA || !window.POPUPS_DATA.length) return;

  const QUEUE_DELAY = 10000; // 10s między popupami
  let queue = [...window.POPUPS_DATA].filter((p) => p.active);
  let isShowing = false;

  function storageKey(id) {
    return `popup_${id}_closed`;
  }

  function canShow(popup) {
    const key = storageKey(popup.id);

    if (popup.afterClose === "never") {
      return !localStorage.getItem(key);
    }

    if (popup.afterClose === "session") {
      return !sessionStorage.getItem(key);
    }

    if (popup.afterClose === "time") {
      const until = localStorage.getItem(key);
      return !until || Date.now() > parseInt(until, 10);
    }

    return true;
  }

  function markClosed(popup) {
    const key = storageKey(popup.id);

    if (popup.afterClose === "never") {
      localStorage.setItem(key, "1");
    }

    if (popup.afterClose === "session") {
      sessionStorage.setItem(key, "1");
    }

    if (popup.afterClose === "time") {
      const minutes = parseInt(popup.afterCloseTime, 10) || 0;
      const until = Date.now() + minutes * 60 * 1000;
      localStorage.setItem(key, until);
    }
  }

  function createPopup(popup) {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = popup.html;

    const fragment = document.createDocumentFragment();
    Array.from(wrapper.children).forEach((el) => fragment.appendChild(el));

    return fragment;
  }

  function showPopup(popup) {
    if (!canShow(popup)) {
      showNext();
      return;
    }

    isShowing = true;

    const fragment = createPopup(popup);
    document.body.appendChild(fragment);

    const el = document.querySelector(`.c-popup[data-popup-id="${popup.id}"]`);
    if (!el) {
      showNext();
      return;
    }

    setTimeout(() => el.classList.add("is-visible"), 50);

    const close = el.querySelector(".c-popup__close");
    const cta = el.querySelector("a");

    function closePopup() {
      el.classList.remove("is-visible");
      markClosed(popup);

      setTimeout(() => {
        el.remove();
        isShowing = false;
        setTimeout(showNext, QUEUE_DELAY);
      }, 300);
    }

    close?.addEventListener("click", closePopup);
    cta?.addEventListener("click", closePopup);
  }

  function showNext() {
    if (isShowing) return;
    const popup = queue.shift();
    if (!popup) return;
    showPopup(popup);
  }

  const start = () => {
    console.log("POPUP START");
    setTimeout(showNext, queue[0]?.startDelay || 5000);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
